const cookies = {
    getCookie( name ) {
        function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
        var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
        return match ? match[1] : null;
    },

    setCookie( name, value, days = 30 ) {
        let expires = `expires=${this.cookieExpire( days )};`
        document.cookie = `${name}=${value}; ${expires} path=/`;
    },

    cookieExpire( days ) {
        var now = new Date();
        var time = now.getTime();
        var expireTime = time + days*24*60*60*1000;
        now.setTime(expireTime);
        return now.toUTCString()
    }
}

export default cookies;
